// var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
// eslint-disable-next-line
var emailFormat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

export const  preFromateDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('-');
}

export const advanceSearchValidation = (numericRange) => {
    if (numericRange.from === '' && numericRange.to !== '') {
        return { status: false, msg: 'Please enter From', field: 'from' };
    } else if (numericRange.from !== '' && numericRange.to === '') {
        return { status: false, msg: 'Please enter To', field: 'to' };
    }
    return { status: true, msg: '' };
}

export const registrationValidation = (registrationData) => {
    if (registrationData.email === '' || registrationData.email === null) {
        return { status: false, msg: 'Please enter your Email', field: 'emailId' };
    } else if (!emailFormat.test(registrationData.email)) {
        return { status: false, msg: 'Please enter a valid Email', field: 'emailId' };
    }
    if (registrationData.userName === "" || registrationData.userName === null) {
        return { status: false, msg: 'Please enter userName', field: "userName" };
    }
    if (registrationData.password === "" || registrationData.password === null) {
        return { status: false, msg: 'Please enter password', field: "password" };
    } else if(registrationData.password.length < 8){
        return { status: false, msg: 'Please enter 8 digit password', field: "password" };
    }
    if (registrationData.confirmPassword === "" || registrationData.confirmPassword !== registrationData.password) {
        return { status: false, msg: 'confirm Password should be same as password', field: "confirmPassword" };
    }
    return { status: true, msg: '' };
}

export const loginValidation = (registrationData) => {
    if (registrationData.email === '' || registrationData.email === null) {
        return { status: false, msg: 'Please enter your Email', field: 'emailId' };
    }
    //  else if (!emailFormat.test(registrationData.email)) {
    //     return { status: false, msg: 'Please enter a valid Email', field: 'emailId' };
    // }
    if (registrationData.password === "" || registrationData.password === null) {
        return { status: false, msg: 'Please enter password', field: "password" };
    } else if(registrationData.password.length < 8){
        return { status: false, msg: 'Please enter 8 digit password', field: "password" };
    }
    return { status: true, msg: '' };
}

export const changePasswordValidation = (changePasswordData) => {
    if (changePasswordData.oldPassword === '' || changePasswordData.oldPassword === null) {
        return { status: false, msg: 'Old password may not be blank.' };
    }
    if (changePasswordData.newPassword === '' || changePasswordData.newPassword === null) {
        return { status: false, msg: 'New password may not be blank.' };
    }
    if (changePasswordData.confirmPassword === '' || changePasswordData.confirmPassword === null) {
        return { status: false, msg: 'Retype new password may not be blank.' };
    }
    return { status: true, msg: '' };
}

export const yearValidation = (yearData) => {
    if (yearData.oldPassword === '' || yearData.oldPassword === null) {
        return { status: false, msg: 'Old password may not be blank.' };
    }
    if (yearData.newPassword === '' || yearData.newPassword === null) {
        return { status: false, msg: 'New password may not be blank.' };
    }
    if (yearData.confirmPassword === '' || yearData.confirmPassword === null) {
        return { status: false, msg: 'Retype new password may not be blank.' };
    }
    return { status: true, msg: '' };
}